import { ISearchProvider } from "../../../../ui/components-lit/GlobalSearch/types";
import { createAlumnoProvider as createAlumnosProvider } from "./alumnos.provider";
import { createAyudaProvider } from "./ayuda.provider";
import { createCalendariosProvider } from "./calendarios.provider";
import { createCalificacionesProvider } from "./calificaciones.provider";
import { createCircularesProvider } from "./circulares.provider";
import { createCovidProvider } from "./covid.provider";
import { createEscuelaProvider as createEscuelasProvider } from "./escuelas.provider";
import { createFinanzasProviders } from "./finanzas.provider";
import { createGraduadosProvider } from "./graduados.provider";
import { createGrupoProvider as createGruposProvider } from "./grupos.provider";
import { createLogrosProvider } from "./logros.provider";
import { createMaestrosProvider } from "./maestros.provider";
import { TGlobalSearchProviderContext } from "./provider.types";
import { createReportesProviders } from "./reportes.provider";
import { createTutoresProvider } from "./tutores.provider";
import { createUsuariosProvider } from "./usuarios.provider";

export const createDefaultProviders = (ctx: TGlobalSearchProviderContext): ISearchProvider[] => {
    return [
        createEscuelasProvider(ctx),
        createGruposProvider(ctx),
        createMaestrosProvider(ctx),
        createCalendariosProvider(ctx),
        createAlumnosProvider(ctx),
        createGraduadosProvider(ctx),
        createTutoresProvider(ctx),
        createCovidProvider(ctx),
        ...createFinanzasProviders(ctx),
        createCircularesProvider(ctx),
        ...createLogrosProvider(ctx),
        ...createCalificacionesProvider(ctx),
        createUsuariosProvider(ctx),
        ...createReportesProviders(ctx),
        ...createAyudaProvider(ctx),
    ];
};
